/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(1);
	
	__webpack_require__(2);
	
	__webpack_require__(3);
	
	__webpack_require__(4);
	
	var _introBlocks = __webpack_require__(5);
	
	var _introBlocks2 = _interopRequireDefault(_introBlocks);
	
	var _Content = __webpack_require__(13);
	
	var _Content2 = _interopRequireDefault(_Content);
	
	var _Carousel = __webpack_require__(17);
	
	var _Carousel2 = _interopRequireDefault(_Carousel);
	
	var _Video = __webpack_require__(18);
	
	var _Video2 = _interopRequireDefault(_Video);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isPage(slug) {
	    return document.querySelector('.page-' + slug);
	}
	
	function ready() {
	    if (isPage('home')) {
	        _introBlocks2.default.init();
	        var vf = new _Video2.default('.background');
	        vf.init();
	    }
	
	    if (isPage('data')) {
	        var c = new _Content2.default();
	        c.load('data');
	    }
	
	    if (isPage('product')) {
	        var _c = new _Content2.default();
	        _c.load('product');
	    }
	
	    _Carousel2.default.init();
	}
	
	document.addEventListener('DOMContentLoaded', ready);

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	module.exports = "<!DOCTYPE html> <html> <head> <meta charset=utf-8 /> <title>Lucas Seidenfaden</title> <meta name=description content=\"Creative Technologist\"/> <link rel=stylesheet href=/dist/css/styles.min.css> <link rel=icon type=image/png href=/favicon-white-black.png> <meta name=viewport content=\"width=device-width,initial-scale=1\"> </head> <body class=page-home> <div id=root></div> <header> <h1>Lucas Seidenfaden – <i>Creative Technologist</i></h1> <h3> <br> I'm a creative technologist at Thought Machine Labs where we explore new ideas in the world of banking and attempt to make the personal finance experience a little more fun and engaging. <br> <br> Outside of Thought Machine you can probably find me playing around with micro-controllers, experimenting in Unity, visualising random datasets or catching some waves. <br> <br> If you want to chat: <a href=mailto:hello@lucasseidenfaden.com>drop me a line</a>. </h3> </header> <div class=background> <div class=bg-img></div> <div class=bg-cover></div> <div class=video-container> <video autoplay muted loop playsinline></video> </div> </div> <div class=content> </div> <script src=/dist/bundle.js></script> </body> </html>";

/***/ }),
/* 2 */
/***/ (function(module, exports) {

	module.exports = "<!DOCTYPE html> <html> <head> <meta charset=utf-8 /> <title>Lucas Seidenfaden – Data</title> <meta name=description content=\"\"/> <link rel=stylesheet href=/dist/css/styles.min.css> <link rel=icon type=image/png href=/favicon-pink.png> </head> <body class=\"page-data cat-page\"> <div id=root></div> <header class=light-content> <h1><a href=/ >Lucas Seidenfaden</a></h1> </header> <div class=menu> <ul> <li><a href=/data>Data</a></li> <li><a href=/product>Product</a></li> <li><a href=/about>About Me</a></li> </ul> </div> <div class=\"intro-block block-data clone wide headerPosition\" style=\"\"> <div class=header-video> <div class=header-video-container style=background-image:url(/assets/video/orangesmoke.jpg);background-size:cover> <video src=/assets/video/orangesmoke.mp4 autoplay muted loop playsinline></video> </div> </div> <div class=text-container> <h2>Data</h2> <p>From PostgresSQL to D3.js – Helping data-driven organisations.</p> </div> </div> <div id=content> </div> <footer> <div class=footer-wrapper> <h1>Lucas Seidenfaden – <i>Creative Technologist</i></h1> <div class=contact-deets> <h3> Want to get in touch? </h3> <ul> <li><a href=mailto:hello@lucasseidenfaden.com>E-Mail</a></li> <li><a href=https://uk.linkedin.com/in/lucasseidenfaden/ rel=noopener target=_blank>LinkedIn</a></li> <li><a href=https://twitter.com/l_sei rel=noopener target=_blank>GitHub</a></li> <li><a href=https://github.com/lsei rel=noopener target=_blank>Twitter</a></li> </ul> </div> </div> </footer> <script src=/dist/bundle.js></script> </body> </html>\t";

/***/ }),
/* 3 */
/***/ (function(module, exports) {

	module.exports = "<!DOCTYPE html> <html> <head> <meta charset=utf-8 /> <title>Lucas Seidenfaden – Data</title> <meta name=description content=\"\"/> <link rel=stylesheet href=/dist/css/styles.min.css> </head> <body class=\"page-product cat-page\"> <div id=root></div> <header class=light-content> <h1><a href=/ >Lucas Seidenfaden</a></h1> </header> <div class=menu> <ul> <li><a href=/data>Data</a></li> <li><a href=/product>Product</a></li> <li><a href=/about>About Me</a></li> </ul> </div> <div class=\"intro-block block-product clone wide headerPosition\" style=\"\"> <div class=header-video> <div class=header-video-container style=background-image:url(/assets/video/bluesmoke.jpg);background-size:cover> <video src=/assets/video/bluesmoke.mp4 autoplay muted loop playsinline></video> </div> </div> <div class=text-container> <h2>Product</h2> <p> From strategy to execution </p> </div> </div> <div id=content> </div> <footer> <div class=footer-wrapper> <h1>Lucas Seidenfaden – <i>Creative Technologist</i></h1> <div class=contact-deets> <h3> Want to get in touch? </h3> <ul> <li><a href=mailto:hello@lucasseidenfaden.com>E-Mail</a></li> <li><a href=https://uk.linkedin.com/in/lucasseidenfaden/ rel=noopener target=_blank>LinkedIn</a></li> <li><a href=https://twitter.com/l_sei rel=noopener target=_blank>GitHub</a></li> <li><a href=https://github.com/lsei rel=noopener target=_blank>Twitter</a></li> </ul> </div> </div> </footer> <script src=/dist/bundle.js></script> </body> </html>\t";

/***/ }),
/* 4 */
/***/ (function(module, exports) {

	module.exports = "<!DOCTYPE html> <html> <head> <meta charset=utf-8 /> <title>Lucas Seidenfaden – About</title> <meta name=description content=\"\"/> <link rel=stylesheet href=/dist/css/styles.min.css> <link rel=icon type=image/png href=/favicon-black-white.png> </head> <body class=page-about> <div id=root></div> <header class=dark-content> <h1><a href=/ >Lucas Seidenfaden</a></h1> </header> <div class=\"menu light-bg\"> <ul> <li><a href=/data>Data</a></li> <li><a href=/product>Product</a></li> <li><a href=/about>About Me</a></li> </ul> </div> <div id=content> <p class=blurb> A technologist at heart I can spend hours trying out a new data analysis framework, DevOps tool or AI platform. At the same time I believe technology is only a means to an end and we need clear visions and goals to apply the right technological solutions to the right problems. </p> <h2> Contact </h2> <ul> <li> <a href=mailto:hello@lucasseidenfaden.com>E-Mail</a> </li> <li> <a href=https://uk.linkedin.com/in/lucasseidenfaden/ rel=noopener target=_blank>LinkedIn</a> </li> <li> <a href=https://twitter.com/l_sei rel=noopener target=_blank>GitHub</a> </li> <li> <a href=https://github.com/lsei rel=noopener target=_blank>Twitter</a> </li> </ul> <h2> Clients </h2> <ul> <li><a href=https://thoughtmachine.net target=_blank rel=noopener>Thought Machine</a></li> <li><a href=https://www.santander.co.uk target=_blank rel=noopener>Santander</a></li> <li><a href=https://killik.com target=_blank rel=noopener>Killik &amp; Co.</a></li> <li><a href=https://rainbowwave.com target=_blank rel=noopener>RainbowWave</a></li> <li><a href=https://touchworldwide.com target=_blank rel=noopener>Touch</a></li> <li><a href=https://starbucks.com target=_blank rel=noopener>Starbucks</a></li> <li><a href=https://microsoft.com target=_blank rel=noopener>Microsoft</a></li> <li>Nokia</li> <li><a href=http://studio-blvd.com target=_blank rel=noopener>Studio Boulevard</a></li> <li>The Wolves</li> <li>Katy Barker</li> <li><a href=https://hexdigital.com/ target=_blank rel=noopener>HEX Digital</a></li> <li><a href=https://bills-website.co.uk/ target=_blank rel=noopener>Bill's</a></li> <li><a href=https://hosb.org.uk/ target=_blank rel=noopener>House of St. Barnabas</a></li> <li><a href=https://www.capitalone.co.uk/ target=_blank rel=noopener>Capital One</a></li> <li><a href=https://lmarks.com/ target=_blank rel=noopener>L Marks</a></li> </ul> <br> <br> <br> <br> <br> </div> <script src=/dist/bundle.js></script> </body> </html>\t";

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(console) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var transitioning = false;
	
	var foreach = function foreach(selector, callback) {
	    var elements = document.querySelectorAll(selector);
	    [].forEach.call(elements, callback);
	};
	
	function handleClickBlock(e) {
	    e.preventDefault();
	
	    transitioning = true;
	    var element = e.target;
	    while (!element.classList.contains('intro-block')) {
	        element = element.parentNode;
	    }
	    var clone = element.cloneNode(true);
	    var rect = element.getBoundingClientRect();
	    var newStyle = {
	        top: rect.y + 'px',
	        left: rect.x + 'px'
	    };
	    Object.assign(clone.style, newStyle);
	    clone.classList.add('clone');
	    document.body.appendChild(clone);
	    clone.offsetHeight;
	    clone.ontransitionend = function () {
	        console.log('ended!');
	        clone.ontransitionend = function () {};
	    };
	    clone.classList.add('wide');
	    Object.assign(clone.style, {
	        left: ''
	    });
	    setTimeout(function () {
	        clone.offsetHeight;
	        clone.classList.add('headerPosition');
	        document.querySelector('header').classList.add('light-content');
	        Object.assign(clone.style, {
	            top: ''
	        });
	        setTimeout(function () {
	            location.href = element.getAttribute('href');
	            transitioning = false;
	        }, 500);
	    }, 500);
	
	    element.parentNode.classList.add('hide');
	    setTimeout(function () {
	        element.parentNode.remove();
	    }, 500);
	}
	
	function setupClickHandlers() {
	    foreach('.intro-block', function (element) {
	        element.addEventListener('click', handleClickBlock);
	    });
	}
	
	function init() {
	    setupClickHandlers();
	}
	
	exports.default = {
	    init: init
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(6)))

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*global window, global*/
	var util = __webpack_require__(7)
	var assert = __webpack_require__(11)
	var now = __webpack_require__(12)
	
	var slice = Array.prototype.slice
	var console
	var times = {}
	
	if (typeof global !== "undefined" && global.console) {
	    console = global.console
	} else if (typeof window !== "undefined" && window.console) {
	    console = window.console
	} else {
	    console = {}
	}
	
	var functions = [
	    [log, "log"],
	    [info, "info"],
	    [warn, "warn"],
	    [error, "error"],
	    [time, "time"],
	    [timeEnd, "timeEnd"],
	    [trace, "trace"],
	    [dir, "dir"],
	    [consoleAssert, "assert"]
	]
	
	for (var i = 0; i < functions.length; i++) {
	    var tuple = functions[i]
	    var f = tuple[0]
	    var name = tuple[1]
	
	    if (!console[name]) {
	        console[name] = f
	    }
	}
	
	module.exports = console
	
	function log() {}
	
	function info() {
	    console.log.apply(console, arguments)
	}
	
	function warn() {
	    console.log.apply(console, arguments)
	}
	
	function error() {
	    console.warn.apply(console, arguments)
	}
	
	function time(label) {
	    times[label] = now()
	}
	
	function timeEnd(label) {
	    var time = times[label]
	    if (!time) {
	        throw new Error("No such label: " + label)
	    }
	
	    var duration = now() - time
	    console.log(label + ": " + duration + "ms")
	}
	
	function trace() {
	    var err = new Error()
	    err.name = "Trace"
	    err.message = util.format.apply(null, arguments)
	    console.error(err.stack)
	}
	
	function dir(object) {
	    console.log(util.inspect(object) + "\n")
	}
	
	function consoleAssert(expression) {
	    if (!expression) {
	        var arr = slice.call(arguments, 1)
	        assert.ok(false, util.format.apply(null, arr))
	    }
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process, console) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	var formatRegExp = /%[sdj%]/g;
	exports.format = function(f) {
	  if (!isString(f)) {
	    var objects = [];
	    for (var i = 0; i < arguments.length; i++) {
	      objects.push(inspect(arguments[i]));
	    }
	    return objects.join(' ');
	  }
	
	  var i = 1;
	  var args = arguments;
	  var len = args.length;
	  var str = String(f).replace(formatRegExp, function(x) {
	    if (x === '%%') return '%';
	    if (i >= len) return x;
	    switch (x) {
	      case '%s': return String(args[i++]);
	      case '%d': return Number(args[i++]);
	      case '%j':
	        try {
	          return JSON.stringify(args[i++]);
	        } catch (_) {
	          return '[Circular]';
	        }
	      default:
	        return x;
	    }
	  });
	  for (var x = args[i]; i < len; x = args[++i]) {
	    if (isNull(x) || !isObject(x)) {
	      str += ' ' + x;
	    } else {
	      str += ' ' + inspect(x);
	    }
	  }
	  return str;
	};
	
	
	// Mark that a method should not be used.
	// Returns a modified function which warns once by default.
	// If --no-deprecation is set, then it is a no-op.
	exports.deprecate = function(fn, msg) {
	  // Allow for deprecating things in the process of starting up.
	  if (isUndefined(global.process)) {
	    return function() {
	      return exports.deprecate(fn, msg).apply(this, arguments);
	    };
	  }
	
	  if (process.noDeprecation === true) {
	    return fn;
	  }
	
	  var warned = false;
	  function deprecated() {
	    if (!warned) {
	      if (process.throwDeprecation) {
	        throw new Error(msg);
	      } else if (process.traceDeprecation) {
	        console.trace(msg);
	      } else {
	        console.error(msg);
	      }
	      warned = true;
	    }
	    return fn.apply(this, arguments);
	  }
	
	  return deprecated;
	};
	
	
	var debugs = {};
	var debugEnviron;
	exports.debuglog = function(set) {
	  if (isUndefined(debugEnviron))
	    debugEnviron = ({"NODE_ENV":"production"}).NODE_DEBUG || '';
	  set = set.toUpperCase();
	  if (!debugs[set]) {
	    if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
	      var pid = process.pid;
	      debugs[set] = function() {
	        var msg = exports.format.apply(exports, arguments);
	        console.error('%s %d: %s', set, pid, msg);
	      };
	    } else {
	      debugs[set] = function() {};
	    }
	  }
	  return debugs[set];
	};
	
	
	/**
	 * Echos the value of a value. Trys to print the value out
	 * in the best way possible given the different types.
	 *
	 * @param {Object} obj The object to print out.
	 * @param {Object} opts Optional options object that alters the output.
	 */
	/* legacy: obj, showHidden, depth, colors*/
	function inspect(obj, opts) {
	  // default options
	  var ctx = {
	    seen: [],
	    stylize: stylizeNoColor
	  };
	  // legacy...
	  if (arguments.length >= 3) ctx.depth = arguments[2];
	  if (arguments.length >= 4) ctx.colors = arguments[3];
	  if (isBoolean(opts)) {
	    // legacy...
	    ctx.showHidden = opts;
	  } else if (opts) {
	    // got an "options" object
	    exports._extend(ctx, opts);
	  }
	  // set default options
	  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
	  if (isUndefined(ctx.depth)) ctx.depth = 2;
	  if (isUndefined(ctx.colors)) ctx.colors = false;
	  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
	  if (ctx.colors) ctx.stylize = stylizeWithColor;
	  return formatValue(ctx, obj, ctx.depth);
	}
	exports.inspect = inspect;
	
	
	// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
	inspect.colors = {
	  'bold' : [1, 22],
	  'italic' : [3, 23],
	  'underline' : [4, 24],
	  'inverse' : [7, 27],
	  'white' : [37, 39],
	  'grey' : [90, 39],
	  'black' : [30, 39],
	  'blue' : [34, 39],
	  'cyan' : [36, 39],
	  'green' : [32, 39],
	  'magenta' : [35, 39],
	  'red' : [31, 39],
	  'yellow' : [33, 39]
	};
	
	// Don't use 'blue' not visible on cmd.exe
	inspect.styles = {
	  'special': 'cyan',
	  'number': 'yellow',
	  'boolean': 'yellow',
	  'undefined': 'grey',
	  'null': 'bold',
	  'string': 'green',
	  'date': 'magenta',
	  // "name": intentionally not styling
	  'regexp': 'red'
	};
	
	
	function stylizeWithColor(str, styleType) {
	  var style = inspect.styles[styleType];
	
	  if (style) {
	    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
	           '\u001b[' + inspect.colors[style][1] + 'm';
	  } else {
	    return str;
	  }
	}
	
	
	function stylizeNoColor(str, styleType) {
	  return str;
	}
	
	
	function arrayToHash(array) {
	  var hash = {};
	
	  array.forEach(function(val, idx) {
	    hash[val] = true;
	  });
	
	  return hash;
	}
	
	
	function formatValue(ctx, value, recurseTimes) {
	  // Provide a hook for user-specified inspect functions.
	  // Check that value is an object with an inspect function on it
	  if (ctx.customInspect &&
	      value &&
	      isFunction(value.inspect) &&
	      // Filter out the util module, it's inspect function is special
	      value.inspect !== exports.inspect &&
	      // Also filter out any prototype objects using the circular check.
	      !(value.constructor && value.constructor.prototype === value)) {
	    var ret = value.inspect(recurseTimes, ctx);
	    if (!isString(ret)) {
	      ret = formatValue(ctx, ret, recurseTimes);
	    }
	    return ret;
	  }
	
	  // Primitive types cannot have properties
	  var primitive = formatPrimitive(ctx, value);
	  if (primitive) {
	    return primitive;
	  }
	
	  // Look up the keys of the object.
	  var keys = Object.keys(value);
	  var visibleKeys = arrayToHash(keys);
	
	  if (ctx.showHidden) {
	    keys = Object.getOwnPropertyNames(value);
	  }
	
	  // IE doesn't make error fields non-enumerable
	  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
	  if (isError(value)
	      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
	    return formatError(value);
	  }
	
	  // Some type of object without properties can be shortcutted.
	  if (keys.length === 0) {
	    if (isFunction(value)) {
	      var name = value.name ? ': ' + value.name : '';
	      return ctx.stylize('[Function' + name + ']', 'special');
	    }
	    if (isRegExp(value)) {
	      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
	    }
	    if (isDate(value)) {
	      return ctx.stylize(Date.prototype.toString.call(value), 'date');
	    }
	    if (isError(value)) {
	      return formatError(value);
	    }
	  }
	
	  var base = '', array = false, braces = ['{', '}'];
	
	  // Make Array say that they are Array
	  if (isArray(value)) {
	    array = true;
	    braces = ['[', ']'];
	  }
	
	  // Make functions say that they are functions
	  if (isFunction(value)) {
	    var n = value.name ? ': ' + value.name : '';
	    base = ' [Function' + n + ']';
	  }
	
	  // Make RegExps say that they are RegExps
	  if (isRegExp(value)) {
	    base = ' ' + RegExp.prototype.toString.call(value);
	  }
	
	  // Make dates with properties first say the date
	  if (isDate(value)) {
	    base = ' ' + Date.prototype.toUTCString.call(value);
	  }
	
	  // Make error with message first say the error
	  if (isError(value)) {
	    base = ' ' + formatError(value);
	  }
	
	  if (keys.length === 0 && (!array || value.length == 0)) {
	    return braces[0] + base + braces[1];
	  }
	
	  if (recurseTimes < 0) {
	    if (isRegExp(value)) {
	      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
	    } else {
	      return ctx.stylize('[Object]', 'special');
	    }
	  }
	
	  ctx.seen.push(value);
	
	  var output;
	  if (array) {
	    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
	  } else {
	    output = keys.map(function(key) {
	      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
	    });
	  }
	
	  ctx.seen.pop();
	
	  return reduceToSingleString(output, base, braces);
	}
	
	
	function formatPrimitive(ctx, value) {
	  if (isUndefined(value))
	    return ctx.stylize('undefined', 'undefined');
	  if (isString(value)) {
	    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
	                                             .replace(/'/g, "\\'")
	                                             .replace(/\\"/g, '"') + '\'';
	    return ctx.stylize(simple, 'string');
	  }
	  if (isNumber(value))
	    return ctx.stylize('' + value, 'number');
	  if (isBoolean(value))
	    return ctx.stylize('' + value, 'boolean');
	  // For some reason typeof null is "object", so special case here.
	  if (isNull(value))
	    return ctx.stylize('null', 'null');
	}
	
	
	function formatError(value) {
	  return '[' + Error.prototype.toString.call(value) + ']';
	}
	
	
	function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
	  var output = [];
	  for (var i = 0, l = value.length; i < l; ++i) {
	    if (hasOwnProperty(value, String(i))) {
	      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
	          String(i), true));
	    } else {
	      output.push('');
	    }
	  }
	  keys.forEach(function(key) {
	    if (!key.match(/^\d+$/)) {
	      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
	          key, true));
	    }
	  });
	  return output;
	}
	
	
	function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
	  var name, str, desc;
	  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
	  if (desc.get) {
	    if (desc.set) {
	      str = ctx.stylize('[Getter/Setter]', 'special');
	    } else {
	      str = ctx.stylize('[Getter]', 'special');
	    }
	  } else {
	    if (desc.set) {
	      str = ctx.stylize('[Setter]', 'special');
	    }
	  }
	  if (!hasOwnProperty(visibleKeys, key)) {
	    name = '[' + key + ']';
	  }
	  if (!str) {
	    if (ctx.seen.indexOf(desc.value) < 0) {
	      if (isNull(recurseTimes)) {
	        str = formatValue(ctx, desc.value, null);
	      } else {
	        str = formatValue(ctx, desc.value, recurseTimes - 1);
	      }
	      if (str.indexOf('\n') > -1) {
	        if (array) {
	          str = str.split('\n').map(function(line) {
	            return '  ' + line;
	          }).join('\n').substr(2);
	        } else {
	          str = '\n' + str.split('\n').map(function(line) {
	            return '   ' + line;
	          }).join('\n');
	        }
	      }
	    } else {
	      str = ctx.stylize('[Circular]', 'special');
	    }
	  }
	  if (isUndefined(name)) {
	    if (array && key.match(/^\d+$/)) {
	      return str;
	    }
	    name = JSON.stringify('' + key);
	    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
	      name = name.substr(1, name.length - 2);
	      name = ctx.stylize(name, 'name');
	    } else {
	      name = name.replace(/'/g, "\\'")
	                 .replace(/\\"/g, '"')
	                 .replace(/(^"|"$)/g, "'");
	      name = ctx.stylize(name, 'string');
	    }
	  }
	
	  return name + ': ' + str;
	}
	
	
	function reduceToSingleString(output, base, braces) {
	  var numLinesEst = 0;
	  var length = output.reduce(function(prev, cur) {
	    numLinesEst++;
	    if (cur.indexOf('\n') >= 0) numLinesEst++;
	    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
	  }, 0);
	
	  if (length > 60) {
	    return braces[0] +
	           (base === '' ? '' : base + '\n ') +
	           ' ' +
	           output.join(',\n  ') +
	           ' ' +
	           braces[1];
	  }
	
	  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
	}
	
	
	// NOTE: These type checking functions intentionally don't use `instanceof`
	// because it is fragile and can be easily faked with `Object.create()`.
	function isArray(ar) {
	  return Array.isArray(ar);
	}
	exports.isArray = isArray;
	
	function isBoolean(arg) {
	  return typeof arg === 'boolean';
	}
	exports.isBoolean = isBoolean;
	
	function isNull(arg) {
	  return arg === null;
	}
	exports.isNull = isNull;
	
	function isNullOrUndefined(arg) {
	  return arg == null;
	}
	exports.isNullOrUndefined = isNullOrUndefined;
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	exports.isNumber = isNumber;
	
	function isString(arg) {
	  return typeof arg === 'string';
	}
	exports.isString = isString;
	
	function isSymbol(arg) {
	  return typeof arg === 'symbol';
	}
	exports.isSymbol = isSymbol;
	
	function isUndefined(arg) {
	  return arg === void 0;
	}
	exports.isUndefined = isUndefined;
	
	function isRegExp(re) {
	  return isObject(re) && objectToString(re) === '[object RegExp]';
	}
	exports.isRegExp = isRegExp;
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	exports.isObject = isObject;
	
	function isDate(d) {
	  return isObject(d) && objectToString(d) === '[object Date]';
	}
	exports.isDate = isDate;
	
	function isError(e) {
	  return isObject(e) &&
	      (objectToString(e) === '[object Error]' || e instanceof Error);
	}
	exports.isError = isError;
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	exports.isFunction = isFunction;
	
	function isPrimitive(arg) {
	  return arg === null ||
	         typeof arg === 'boolean' ||
	         typeof arg === 'number' ||
	         typeof arg === 'string' ||
	         typeof arg === 'symbol' ||  // ES6 symbol
	         typeof arg === 'undefined';
	}
	exports.isPrimitive = isPrimitive;
	
	exports.isBuffer = __webpack_require__(9);
	
	function objectToString(o) {
	  return Object.prototype.toString.call(o);
	}
	
	
	function pad(n) {
	  return n < 10 ? '0' + n.toString(10) : n.toString(10);
	}
	
	
	var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
	              'Oct', 'Nov', 'Dec'];
	
	// 26 Feb 16:19:34
	function timestamp() {
	  var d = new Date();
	  var time = [pad(d.getHours()),
	              pad(d.getMinutes()),
	              pad(d.getSeconds())].join(':');
	  return [d.getDate(), months[d.getMonth()], time].join(' ');
	}
	
	
	// log is just a thin wrapper to console.log that prepends a timestamp
	exports.log = function() {
	  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
	};
	
	
	/**
	 * Inherit the prototype methods from one constructor into another.
	 *
	 * The Function.prototype.inherits from lang.js rewritten as a standalone
	 * function (not on Function.prototype). NOTE: If this file is to be loaded
	 * during bootstrapping this function needs to be rewritten using some native
	 * functions as prototype setup using normal JavaScript does not work as
	 * expected during bootstrapping (see mirror.js in r114903).
	 *
	 * @param {function} ctor Constructor function which needs to inherit the
	 *     prototype.
	 * @param {function} superCtor Constructor function to inherit prototype from.
	 */
	exports.inherits = __webpack_require__(10);
	
	exports._extend = function(origin, add) {
	  // Don't do anything if add isn't an object
	  if (!add || !isObject(add)) return origin;
	
	  var keys = Object.keys(add);
	  var i = keys.length;
	  while (i--) {
	    origin[keys[i]] = add[keys[i]];
	  }
	  return origin;
	};
	
	function hasOwnProperty(obj, prop) {
	  return Object.prototype.hasOwnProperty.call(obj, prop);
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(8), __webpack_require__(6)))

/***/ }),
/* 8 */
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),
/* 9 */
/***/ (function(module, exports) {

	module.exports = function isBuffer(arg) {
	  return arg && typeof arg === 'object'
	    && typeof arg.copy === 'function'
	    && typeof arg.fill === 'function'
	    && typeof arg.readUInt8 === 'function';
	}

/***/ }),
/* 10 */
/***/ (function(module, exports) {

	if (typeof Object.create === 'function') {
	  // implementation from standard node.js 'util' module
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    ctor.prototype = Object.create(superCtor.prototype, {
	      constructor: {
	        value: ctor,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	  };
	} else {
	  // old school shim for old browsers
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    var TempCtor = function () {}
	    TempCtor.prototype = superCtor.prototype
	    ctor.prototype = new TempCtor()
	    ctor.prototype.constructor = ctor
	  }
	}


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	// compare and isBuffer taken from https://github.com/feross/buffer/blob/680e9e5e488f22aac27599a57dc844a6315928dd/index.js
	// original notice:
	
	/*!
	 * The buffer module from node.js, for the browser.
	 *
	 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
	 * @license  MIT
	 */
	function compare(a, b) {
	  if (a === b) {
	    return 0;
	  }
	
	  var x = a.length;
	  var y = b.length;
	
	  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
	    if (a[i] !== b[i]) {
	      x = a[i];
	      y = b[i];
	      break;
	    }
	  }
	
	  if (x < y) {
	    return -1;
	  }
	  if (y < x) {
	    return 1;
	  }
	  return 0;
	}
	function isBuffer(b) {
	  if (global.Buffer && typeof global.Buffer.isBuffer === 'function') {
	    return global.Buffer.isBuffer(b);
	  }
	  return !!(b != null && b._isBuffer);
	}
	
	// based on node assert, original notice:
	
	// http://wiki.commonjs.org/wiki/Unit_Testing/1.0
	//
	// THIS IS NOT TESTED NOR LIKELY TO WORK OUTSIDE V8!
	//
	// Originally from narwhal.js (http://narwhaljs.org)
	// Copyright (c) 2009 Thomas Robinson <280north.com>
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the 'Software'), to
	// deal in the Software without restriction, including without limitation the
	// rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
	// sell copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
	// ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
	// WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	var util = __webpack_require__(7);
	var hasOwn = Object.prototype.hasOwnProperty;
	var pSlice = Array.prototype.slice;
	var functionsHaveNames = (function () {
	  return function foo() {}.name === 'foo';
	}());
	function pToString (obj) {
	  return Object.prototype.toString.call(obj);
	}
	function isView(arrbuf) {
	  if (isBuffer(arrbuf)) {
	    return false;
	  }
	  if (typeof global.ArrayBuffer !== 'function') {
	    return false;
	  }
	  if (typeof ArrayBuffer.isView === 'function') {
	    return ArrayBuffer.isView(arrbuf);
	  }
	  if (!arrbuf) {
	    return false;
	  }
	  if (arrbuf instanceof DataView) {
	    return true;
	  }
	  if (arrbuf.buffer && arrbuf.buffer instanceof ArrayBuffer) {
	    return true;
	  }
	  return false;
	}
	// 1. The assert module provides functions that throw
	// AssertionError's when particular conditions are not met. The
	// assert module must conform to the following interface.
	
	var assert = module.exports = ok;
	
	// 2. The AssertionError is defined in assert.
	// new assert.AssertionError({ message: message,
	//                             actual: actual,
	//                             expected: expected })
	
	var regex = /\s*function\s+([^\(\s]*)\s*/;
	// based on https://github.com/ljharb/function.prototype.name/blob/adeeeec8bfcc6068b187d7d9fb3d5bb1d3a30899/implementation.js
	function getName(func) {
	  if (!util.isFunction(func)) {
	    return;
	  }
	  if (functionsHaveNames) {
	    return func.name;
	  }
	  var str = func.toString();
	  var match = str.match(regex);
	  return match && match[1];
	}
	assert.AssertionError = function AssertionError(options) {
	  this.name = 'AssertionError';
	  this.actual = options.actual;
	  this.expected = options.expected;
	  this.operator = options.operator;
	  if (options.message) {
	    this.message = options.message;
	    this.generatedMessage = false;
	  } else {
	    this.message = getMessage(this);
	    this.generatedMessage = true;
	  }
	  var stackStartFunction = options.stackStartFunction || fail;
	  if (Error.captureStackTrace) {
	    Error.captureStackTrace(this, stackStartFunction);
	  } else {
	    // non v8 browsers so we can have a stacktrace
	    var err = new Error();
	    if (err.stack) {
	      var out = err.stack;
	
	      // try to strip useless frames
	      var fn_name = getName(stackStartFunction);
	      var idx = out.indexOf('\n' + fn_name);
	      if (idx >= 0) {
	        // once we have located the function frame
	        // we need to strip out everything before it (and its line)
	        var next_line = out.indexOf('\n', idx + 1);
	        out = out.substring(next_line + 1);
	      }
	
	      this.stack = out;
	    }
	  }
	};
	
	// assert.AssertionError instanceof Error
	util.inherits(assert.AssertionError, Error);
	
	function truncate(s, n) {
	  if (typeof s === 'string') {
	    return s.length < n ? s : s.slice(0, n);
	  } else {
	    return s;
	  }
	}
	function inspect(something) {
	  if (functionsHaveNames || !util.isFunction(something)) {
	    return util.inspect(something);
	  }
	  var rawname = getName(something);
	  var name = rawname ? ': ' + rawname : '';
	  return '[Function' +  name + ']';
	}
	function getMessage(self) {
	  return truncate(inspect(self.actual), 128) + ' ' +
	         self.operator + ' ' +
	         truncate(inspect(self.expected), 128);
	}
	
	// At present only the three keys mentioned above are used and
	// understood by the spec. Implementations or sub modules can pass
	// other keys to the AssertionError's constructor - they will be
	// ignored.
	
	// 3. All of the following functions must throw an AssertionError
	// when a corresponding condition is not met, with a message that
	// may be undefined if not provided.  All assertion methods provide
	// both the actual and expected values to the assertion error for
	// display purposes.
	
	function fail(actual, expected, message, operator, stackStartFunction) {
	  throw new assert.AssertionError({
	    message: message,
	    actual: actual,
	    expected: expected,
	    operator: operator,
	    stackStartFunction: stackStartFunction
	  });
	}
	
	// EXTENSION! allows for well behaved errors defined elsewhere.
	assert.fail = fail;
	
	// 4. Pure assertion tests whether a value is truthy, as determined
	// by !!guard.
	// assert.ok(guard, message_opt);
	// This statement is equivalent to assert.equal(true, !!guard,
	// message_opt);. To test strictly for the value true, use
	// assert.strictEqual(true, guard, message_opt);.
	
	function ok(value, message) {
	  if (!value) fail(value, true, message, '==', assert.ok);
	}
	assert.ok = ok;
	
	// 5. The equality assertion tests shallow, coercive equality with
	// ==.
	// assert.equal(actual, expected, message_opt);
	
	assert.equal = function equal(actual, expected, message) {
	  if (actual != expected) fail(actual, expected, message, '==', assert.equal);
	};
	
	// 6. The non-equality assertion tests for whether two objects are not equal
	// with != assert.notEqual(actual, expected, message_opt);
	
	assert.notEqual = function notEqual(actual, expected, message) {
	  if (actual == expected) {
	    fail(actual, expected, message, '!=', assert.notEqual);
	  }
	};
	
	// 7. The equivalence assertion tests a deep equality relation.
	// assert.deepEqual(actual, expected, message_opt);
	
	assert.deepEqual = function deepEqual(actual, expected, message) {
	  if (!_deepEqual(actual, expected, false)) {
	    fail(actual, expected, message, 'deepEqual', assert.deepEqual);
	  }
	};
	
	assert.deepStrictEqual = function deepStrictEqual(actual, expected, message) {
	  if (!_deepEqual(actual, expected, true)) {
	    fail(actual, expected, message, 'deepStrictEqual', assert.deepStrictEqual);
	  }
	};
	
	function _deepEqual(actual, expected, strict, memos) {
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (actual === expected) {
	    return true;
	  } else if (isBuffer(actual) && isBuffer(expected)) {
	    return compare(actual, expected) === 0;
	
	  // 7.2. If the expected value is a Date object, the actual value is
	  // equivalent if it is also a Date object that refers to the same time.
	  } else if (util.isDate(actual) && util.isDate(expected)) {
	    return actual.getTime() === expected.getTime();
	
	  // 7.3 If the expected value is a RegExp object, the actual value is
	  // equivalent if it is also a RegExp object with the same source and
	  // properties (`global`, `multiline`, `lastIndex`, `ignoreCase`).
	  } else if (util.isRegExp(actual) && util.isRegExp(expected)) {
	    return actual.source === expected.source &&
	           actual.global === expected.global &&
	           actual.multiline === expected.multiline &&
	           actual.lastIndex === expected.lastIndex &&
	           actual.ignoreCase === expected.ignoreCase;
	
	  // 7.4. Other pairs that do not both pass typeof value == 'object',
	  // equivalence is determined by ==.
	  } else if ((actual === null || typeof actual !== 'object') &&
	             (expected === null || typeof expected !== 'object')) {
	    return strict ? actual === expected : actual == expected;
	
	  // If both values are instances of typed arrays, wrap their underlying
	  // ArrayBuffers in a Buffer each to increase performance
	  // This optimization requires the arrays to have the same type as checked by
	  // Object.prototype.toString (aka pToString). Never perform binary
	  // comparisons for Float*Arrays, though, since e.g. +0 === -0 but their
	  // bit patterns are not identical.
	  } else if (isView(actual) && isView(expected) &&
	             pToString(actual) === pToString(expected) &&
	             !(actual instanceof Float32Array ||
	               actual instanceof Float64Array)) {
	    return compare(new Uint8Array(actual.buffer),
	                   new Uint8Array(expected.buffer)) === 0;
	
	  // 7.5 For all other Object pairs, including Array objects, equivalence is
	  // determined by having the same number of owned properties (as verified
	  // with Object.prototype.hasOwnProperty.call), the same set of keys
	  // (although not necessarily the same order), equivalent values for every
	  // corresponding key, and an identical 'prototype' property. Note: this
	  // accounts for both named and indexed properties on Arrays.
	  } else if (isBuffer(actual) !== isBuffer(expected)) {
	    return false;
	  } else {
	    memos = memos || {actual: [], expected: []};
	
	    var actualIndex = memos.actual.indexOf(actual);
	    if (actualIndex !== -1) {
	      if (actualIndex === memos.expected.indexOf(expected)) {
	        return true;
	      }
	    }
	
	    memos.actual.push(actual);
	    memos.expected.push(expected);
	
	    return objEquiv(actual, expected, strict, memos);
	  }
	}
	
	function isArguments(object) {
	  return Object.prototype.toString.call(object) == '[object Arguments]';
	}
	
	function objEquiv(a, b, strict, actualVisitedObjects) {
	  if (a === null || a === undefined || b === null || b === undefined)
	    return false;
	  // if one is a primitive, the other must be same
	  if (util.isPrimitive(a) || util.isPrimitive(b))
	    return a === b;
	  if (strict && Object.getPrototypeOf(a) !== Object.getPrototypeOf(b))
	    return false;
	  var aIsArgs = isArguments(a);
	  var bIsArgs = isArguments(b);
	  if ((aIsArgs && !bIsArgs) || (!aIsArgs && bIsArgs))
	    return false;
	  if (aIsArgs) {
	    a = pSlice.call(a);
	    b = pSlice.call(b);
	    return _deepEqual(a, b, strict);
	  }
	  var ka = objectKeys(a);
	  var kb = objectKeys(b);
	  var key, i;
	  // having the same number of owned properties (keys incorporates
	  // hasOwnProperty)
	  if (ka.length !== kb.length)
	    return false;
	  //the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  //~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] !== kb[i])
	      return false;
	  }
	  //equivalent values for every corresponding key, and
	  //~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!_deepEqual(a[key], b[key], strict, actualVisitedObjects))
	      return false;
	  }
	  return true;
	}
	
	// 8. The non-equivalence assertion tests for any deep inequality.
	// assert.notDeepEqual(actual, expected, message_opt);
	
	assert.notDeepEqual = function notDeepEqual(actual, expected, message) {
	  if (_deepEqual(actual, expected, false)) {
	    fail(actual, expected, message, 'notDeepEqual', assert.notDeepEqual);
	  }
	};
	
	assert.notDeepStrictEqual = notDeepStrictEqual;
	function notDeepStrictEqual(actual, expected, message) {
	  if (_deepEqual(actual, expected, true)) {
	    fail(actual, expected, message, 'notDeepStrictEqual', notDeepStrictEqual);
	  }
	}
	
	
	// 9. The strict equality assertion tests strict equality, as determined by ===.
	// assert.strictEqual(actual, expected, message_opt);
	
	assert.strictEqual = function strictEqual(actual, expected, message) {
	  if (actual !== expected) {
	    fail(actual, expected, message, '===', assert.strictEqual);
	  }
	};
	
	// 10. The strict non-equality assertion tests for strict inequality, as
	// determined by !==.  assert.notStrictEqual(actual, expected, message_opt);
	
	assert.notStrictEqual = function notStrictEqual(actual, expected, message) {
	  if (actual === expected) {
	    fail(actual, expected, message, '!==', assert.notStrictEqual);
	  }
	};
	
	function expectedException(actual, expected) {
	  if (!actual || !expected) {
	    return false;
	  }
	
	  if (Object.prototype.toString.call(expected) == '[object RegExp]') {
	    return expected.test(actual);
	  }
	
	  try {
	    if (actual instanceof expected) {
	      return true;
	    }
	  } catch (e) {
	    // Ignore.  The instanceof check doesn't work for arrow functions.
	  }
	
	  if (Error.isPrototypeOf(expected)) {
	    return false;
	  }
	
	  return expected.call({}, actual) === true;
	}
	
	function _tryBlock(block) {
	  var error;
	  try {
	    block();
	  } catch (e) {
	    error = e;
	  }
	  return error;
	}
	
	function _throws(shouldThrow, block, expected, message) {
	  var actual;
	
	  if (typeof block !== 'function') {
	    throw new TypeError('"block" argument must be a function');
	  }
	
	  if (typeof expected === 'string') {
	    message = expected;
	    expected = null;
	  }
	
	  actual = _tryBlock(block);
	
	  message = (expected && expected.name ? ' (' + expected.name + ').' : '.') +
	            (message ? ' ' + message : '.');
	
	  if (shouldThrow && !actual) {
	    fail(actual, expected, 'Missing expected exception' + message);
	  }
	
	  var userProvidedMessage = typeof message === 'string';
	  var isUnwantedException = !shouldThrow && util.isError(actual);
	  var isUnexpectedException = !shouldThrow && actual && !expected;
	
	  if ((isUnwantedException &&
	      userProvidedMessage &&
	      expectedException(actual, expected)) ||
	      isUnexpectedException) {
	    fail(actual, expected, 'Got unwanted exception' + message);
	  }
	
	  if ((shouldThrow && actual && expected &&
	      !expectedException(actual, expected)) || (!shouldThrow && actual)) {
	    throw actual;
	  }
	}
	
	// 11. Expected to throw an error:
	// assert.throws(block, Error_opt, message_opt);
	
	assert.throws = function(block, /*optional*/error, /*optional*/message) {
	  _throws(true, block, error, message);
	};
	
	// EXTENSION! This is annoying to write outside this module.
	assert.doesNotThrow = function(block, /*optional*/error, /*optional*/message) {
	  _throws(false, block, error, message);
	};
	
	assert.ifError = function(err) { if (err) throw err; };
	
	var objectKeys = Object.keys || function (obj) {
	  var keys = [];
	  for (var key in obj) {
	    if (hasOwn.call(obj, key)) keys.push(key);
	  }
	  return keys;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 12 */
/***/ (function(module, exports) {

	module.exports = now
	
	function now() {
	    return new Date().getTime()
	}


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _content = __webpack_require__(14);
	
	var blocks = _interopRequireWildcard(_content);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Content = function () {
	    function Content() {
	        _classCallCheck(this, Content);
	
	        this.container = document.querySelector('#content');
	    }
	
	    _createClass(Content, [{
	        key: 'load',
	        value: function load(slug) {
	            var html = blocks[slug];
	            this.container.innerHTML = html;
	        }
	    }]);
	
	    return Content;
	}();
	
	exports.default = Content;

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.product = exports.data = undefined;
	
	var _data = __webpack_require__(15);
	
	var _data2 = _interopRequireDefault(_data);
	
	var _product = __webpack_require__(16);
	
	var _product2 = _interopRequireDefault(_product);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.data = _data2.default;
	exports.product = _product2.default;

/***/ }),
/* 15 */
/***/ (function(module, exports) {

	module.exports = "<p class=intro> Managing and understanding data is vital in today's data-driven world. My data work focuses on establishing clear models for data storage and creating the tools to enable everyone to access and analyse it. </p> <div class=\"block block-carousel\"> <div class=images-container> <div class=slider> <img src=/assets/img/rwi/rwi_login.png alt=\"\"> <img src=/assets/img/rwi/rwi_maker_pie.png alt=\"\"> <img src=/assets/img/rwi/rwi_maker_text.png alt=\"\"> <img src=/assets/img/rwi/rwi_maker_images3.png alt=\"\"> <img src=/assets/img/rwi/rwi_order.png alt=\"\"> <img src=/assets/img/rwi/rwi_store.png alt=\"\"> <img src=/assets/img/rwi/rwi_store_buying.png alt=\"\"> <img src=/assets/img/rwi/rwi_brand_stats.png alt=\"\"> <img src=/assets/img/rwi/rwi_budget.png alt=\"\"> </div> </div> <div class=pagination> <div class=dot></div> <div class=dot></div> <div class=dot></div> </div> <div class=arrows> <div class=left> &lt; </div> <div class=right> &gt; </div> </div> </div> <div class=\"inline-text spacer-top spacer-bottom\"> <h2>Rainbowwave Insights</h2> <h3>A web app to manage contact and analyse revenue.</h3> <p> Rainbowwave Insights (RWI) is a cloud-based Business Intelligence and CRM tool created exclusively for Rainbowwave. As a fashion showroom, Rainbowwave's key assets are their connections to their customers. In order to manage these connections adequately, with an ever expanding team, Rainbowwave commissioned a bespoke system in which they could store and manage all of their sales and contact data in one central location. </p> <p> In addition to managing contacts, RWI also stores all sales and order information for all brands across the showroom. Traditionally all sales reporting was done by laboriously compiling excel sheets and creating pivot tables. By standardising the order format and storing all orders in one central database, along with an easy to use data discovery tool we empower everyone in the company to find and use the insights they need. </p> <ul class=tags> <li>Web App</li> <li>Fashion Industry</li> <li>Analytics</li> <li>Business Intelligence</li> <li>PostgreSQL</li> <li>React.js</li> <li>PHP</li> </ul> </div> <div class=\"block block-carousel\"> <div class=images-container> <div class=slider> <img src=/assets/img/fashionlink.jpg alt=\"\"> <img src=/assets/img/fashionlink/Dashboard.png alt=\"\"> <img src=/assets/img/fashionlink/Regions.png alt=\"\"> <img src=/assets/img/fashionlink/Images.png alt=\"\"> <img src=/assets/img/fashionlink/StockSwap.png alt=\"\"> </div> </div> <div class=pagination> <div class=dot></div> <div class=dot></div> <div class=dot></div> </div> <div class=arrows> <div class=left> &lt; </div> <div class=right> &gt; </div> </div> </div> <div class=\"inline-text spacer-top spacer-bottom\"> <h2>Fashion Link</h2> <h3>A platform connecting wholesalers to their retail sales.</h3> <p> Fashion Link is an online SaaS product that helps wholesale fashion businesses manage and analyse their sell-through data. Many fashion brands struggle to maintain a clear picture of how well their stockists are selling their product. Many times the bi-annual sales appointment and an occasional phone call is the only feedback a brand will get on their collection's performance. Fashion Link helps brands aggregate quantitate data from stores into one holistic view which can be used to manage clients in-season as well as get a historical view of the brands' overall performance. </p> <p> Using Fashion Link helps brands find best selling styles, colourways and product categories as well as discover underserved territories or price points. The reports can easily be shared with the team or used in client appointments. </p> <ul class=tags> <li>Web App</li> <li>Wholesale Fashion</li> <li>Analytics</li> <li>MySQL</li> <li>PHP</li> </ul> </div> <div class=\"block block-image-with-text\"> <img src=/assets/img/discogs1.jpg alt=\"\"> </div> <div class=\"inline-text spacer-top spacer-bottom\"> <h2>Discogs</h2> <h3>Visualising music history through data</h3> <p> Discogs is the largest online marketplace for second-hand media. Every month Discogs publish their dataset of all of the artists, labels and releases on their platform as XML files. Following my passion for music and data, I set about analysing this treasure trove of information.<br> <br> Below is the result of this exploration and here's a blog post of how I got there. </p> <ul class=tags> <li>Data Visualisation</li> <li>Amazon Web Services</li> <li>PostgreSQL</li> <li>D3.js</li> </ul> </div> <div class=\"block block-carousel\"> <div class=images-container> <div class=slider> <img src=/assets/img/monzo1.jpg alt=\"\"/> <img src=/assets/img/monzo2.jpg alt=\"\"/> <img src=/assets/img/monzo3.jpg alt=\"\"/> <img src=/assets/img/monzo4.jpg alt=\"\"/> <img src=/assets/img/monzo5.jpg alt=\"\"/> <img src=/assets/img/monzo6.jpg alt=\"\"/> </div> </div> <div class=pagination> <div class=dot></div> <div class=dot></div> <div class=dot></div> </div> <div class=arrows> <div class=left> &lt; </div> <div class=right> &gt; </div> </div> </div> <div class=\"inline-text spacer-top spacer-bottom\"> <h2>Monlytics</h2> <h3>Digging into personal finance</h3> <p> Using the Monzo API Monlytics is an analytics dashboard for your Monzo account. The site focusses on different angles of your spending, and each page is a journey into your spending history. Using the rich data supplied by the Monzo API we're able to visualise the data in various ways to. Due to the Monzo API still being beta it's not available to the public. Get in touch to try it out! </p> <ul class=tags> <li>Data Visualisation</li> <li>Personal Finance</li> <li>API</li> <li>React.js</li> <li>D3.js</li> </ul> </div> ";

/***/ }),
/* 16 */
/***/ (function(module, exports) {

	module.exports = "<p class=intro> I love taking raw ideas and moulding into a finished piece. My product work focuses on using design thinking techniques to make sure we're working on the right thing, to developing MVPs and apps with the latest engineering best-practices. </p> <div class=\"block block-carousel\"> <div class=images-container> <div class=slider> <img src=/assets/img/chipper/chipper.png alt=\"\"> <img src=/assets/img/chipper/chipper2.png alt=\"\"> <img src=/assets/img/chipper/chipper3.png alt=\"\"> <img src=/assets/img/chipper/chipper4.png alt=\"\"> <img src=/assets/img/chipper/chipper5.png alt=\"\"> </div> </div> <div class=pagination> <div class=dot></div> <div class=dot></div> <div class=dot></div> </div> <div class=arrows> <div class=left> &lt; </div> <div class=right> &gt; </div> </div> </div> <div class=\"inline-text spacer-top spacer-bottom\"> <h2> Chipper <div class=confidential> <img src=/assets/img/lock.svg alt=Lock> <div class=caption> You are viewing a special version of this site. Please keep this project confidential. </div> </div> </h2> <h3>A mortgage repayment app that helps you lose interest.</h3> <p> \"Pay off your mortgage quicker, with Chipper.\" Buying a house is most likely one of the most significant financial decisions you will make in your lifetime. Chipper is an app the sits on top of your mortgage and helps you save money and reduce the term of your mortgage in an easy and fun way. <br/> <br/> Leveraging Thought Machine's core banking system, Vault, users are encouraged to make small daily over-payments to their mortgage. Using the most the world's favourite comparison: by paying in the cost of a cup of coffee a day, you can save over £10,000 in interest payments and close your mortgage significantly earlier. <br/> <br/> The proof-of-concept for Chipper was built using React and Paper.js to create a visually stunning and highly functional web-app. </p> <ul class=tags> <li>Web App</li> <li>Mortgages</li> <li>Personal Finance</li> <li>React.js</li> <li>Paper.js</li> </ul> </div> <div class=\"block block-image-with-text\"> <img src=/assets/img/pace.png alt=P.A.C.E.> </div> <div class=\"inline-text spacer-top spacer-bottom\"> <h2>P.A.C.E.</h2> <h3>The app that keeps your speed up.</h3> <p> The best products are built out of necesity. Although I only run semi-regularly, I wanted to be able to run at a consistent speed throughout the whole duration of my run. All of the solutions I found on the app store were either too complex and multi-faceted or just didn't give me the right type of feedback. The bulk of running apps I found were able to tell me my average or current pace only on the screen of the app or at predetermined intervals. Neither of this was viable as I didn't want to check my phone screen repeatedly, and by the time I heard my average pace I was already too slow. <br> <br> Enter P.A.C.E. The app that gives you audio queues to maintain your target running speed. P.A.C.E. tracks your run and gives you instant audio feedback as soon as you fall out of your target range. This rapid feedback ensures that you maintain a minimum pace while also keeping to a maximum speed. </p> <p class=artwork-credits> \"Midnight City\" artwork via levels.io </p> <ul class=tags> <li>Work-In-Progress</li> <li>Mobile App</li> <li>Fitness</li> <li>React Native</li> </ul> </div> <div class=\"block block-image-with-text\"> <img src=/assets/img/spice2.jpg alt=\"Spice Poster\"> </div> <div class=\"inline-text spacer-top spacer-bottom\"> <h2>Spice</h2> <h3>“He who controls the spice controls the universe.” Frank Herbert famously writes in <i>Dune</i>.</h3> <p> Spice is a game based on the world of Arrakis where the spice melange is harvested and mined. Inspired by the novel and the video game \"Dune 2000\" I created a concept game on top of an Ethereum blockchain. Users can mine spice, build up their army and conquer territories. The game implements multiple tokenisation standards such as ERC-20 as a counter for the spice and ERC-721 for non-fungible tokens (the same protocol CryptoKitties uses). </p> <p class=artwork-credits> Dune artwork by <a href=https://www.artstation.com/manuel2k10 rel=noopener target=_blank>Manuel Robles</a> </p> <ul class=tags> <li>Web App</li> <li>Blockchain</li> <li>Ethereum</li> <li>Concept Stage</li> </ul> </div> <div class=\"block block-image-with-text\"> <img src=/assets/img/dante3.jpg alt=\"\"> <div class=text> <p> </p> </div> </div> <div class=\"inline-text spacer-top spacer-bottom\"> <h2>Colosseum / Inferno</h2> <h3>Colosseum and Inferno are game concepts which explore an alternative approach to personal finance. </h3> <p> Colosseum pitches Good against Evil in your finances, helping develop positive habits in your life while reducing unnecessary expenditure. In an ancient world somewhere between Athens and Rome the gods and demons are pitted against each other in an unholy battle of the finances. Every card transaction you make gives power to either gods or demons determining the outcome of the weekly battle in the never-ending war or prosperity.<br> <br> Inferno is a journey through your financial spending. Modelled after Dante's Inferno the app starts deep in the pit of hell, deepest Inferno. Slowly the user is taken through the nine circles to come back out, stronger than before. </p> <ul class=tags> <li>Mobile App</li> <li>Personal Finance</li> <li>Concept Stage</li> </ul> </div> ";

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(console) {'use strict';
	
	var containerSelector = '.block-carousel';
	
	function initialiseCarousel(element) {
	    setSliderWidth(element);
	    createDots(element);
	
	    var currentSlide = 0;
	    var images = element.querySelectorAll('.slider img');
	
	    // Set left and right click handlers
	    console.log(element.querySelector('.left'));
	    element.querySelector('.left').addEventListener('click', function () {
	        if (currentSlide === 0) return;
	        currentSlide -= 1;
	        gotoSlide(element, currentSlide);
	    });
	
	    element.querySelector('.right').addEventListener('click', function () {
	        if (currentSlide >= images.length - 1) return;
	        currentSlide += 1;
	        gotoSlide(element, currentSlide);
	    });
	}
	
	function gotoSlide(element, index) {
	    element.querySelector('.slider').style.left = -100 * index + '%';
	    highlightDot(element, index);
	}
	
	function setSliderWidth(element) {
	    var images = element.querySelectorAll('.slider img');
	    element.querySelector('.slider').style.width = 100 * images.length + '%';
	}
	
	function createDots(element) {
	    var images = element.querySelectorAll('.slider img');
	    var html = [].map.call(images, function (k, i) {
	        return '<div class="dot ' + (i === 0 ? 'active' : '') + '" data-key="' + i + '"></div>';
	    }).join('');
	    element.querySelector('.pagination').innerHTML = html;
	}
	
	function highlightDot(element, index) {
	    var blocks = element.querySelectorAll('.dot');
	    [].forEach.call(blocks, function (elem) {
	        elem.classList.remove('active');
	    });
	
	    element.querySelector('.dot:nth-child(' + (index + 1) + ')').classList.add('active');
	}
	
	function init() {
	    var blocks = document.querySelectorAll(containerSelector);
	    [].forEach.call(blocks, initialiseCarousel);
	}
	
	module.exports = {
	    init: init
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(6)))

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _utils = __webpack_require__(19);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var maxOpacity = 0.75;
	var topOffset = 200;
	var mobileSize = 425;
	var VIDEO_SRC = "/assets/video/background_paint_loop_hq.mp4";
	
	var Video = function () {
	    function Video(selector) {
	        _classCallCheck(this, Video);
	
	        this.container = document.querySelector(selector);
	        this.elem = this.container.querySelector('.bg-cover');
	        this.video = this.container.querySelector('video');
	    }
	
	    _createClass(Video, [{
	        key: 'init',
	        value: function init() {
	            // this.setupListeners.bind(this)();
	            window.addEventListener('resize', this.onWindowResize.bind(this));
	            if (!isMobile()) {
	                this.loadVideo.bind(this)();
	            }
	        }
	    }, {
	        key: 'loadVideo',
	        value: function loadVideo() {
	            this.video.src = VIDEO_SRC;
	        }
	    }, {
	        key: 'setupListeners',
	        value: function setupListeners() {
	            this.maxScroll = window.innerHeight * 0.5;
	            window.addEventListener('scroll', this.onScroll.bind(this));
	
	            setTimeout(this.onScroll.bind(this), 100);
	        }
	    }, {
	        key: 'onWindowResize',
	        value: function onWindowResize() {
	            this.maxScroll = window.innerHeight * 0.5;
	            if (!isMobile()) {
	                this.video.src = VIDEO_SRC;
	            }
	        }
	    }, {
	        key: 'onScroll',
	        value: function onScroll() {
	            var targetOpacity = Math.max(Math.min((window.scrollY - topOffset) / this.maxScroll, maxOpacity), 0);
	            this.elem.style.opacity = targetOpacity;
	        }
	    }]);
	
	    return Video;
	}();
	
	exports.default = Video;
	
	
	var isMobile = function isMobile() {
	    return window.innerWidth <= mobileSize;
	};

/***/ }),
/* 19 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var throttle = exports.throttle = function throttle(func, limit) {
	    var inThrottle = void 0;
	    return function () {
	        var args = arguments;
	        var context = this;
	        if (!inThrottle) {
	            func.apply(context, args);
	            inThrottle = true;
	            setTimeout(function () {
	                return inThrottle = false;
	            }, limit);
	        }
	    };
	};

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// bundle.js